import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between border-bottom border-2 pb-4 mb-4" }
const _hoisted_2 = { class: "fs-5 d-flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", { class: "text-sm text-gray-500" }, "- Only in Brazil", -1)
const _hoisted_5 = { class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container" }
const _hoisted_6 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_7 = { class: "required" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_11 = { class: "required" }
const _hoisted_12 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "CPF")
], -1)
const _hoisted_15 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_16 = {
  key: 1,
  class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "CNPJ")
], -1)
const _hoisted_18 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_19 = { class: "fs-4 my-7" }
const _hoisted_20 = { class: "row mb-7" }
const _hoisted_21 = { class: "col-12 col-lg-6" }
const _hoisted_22 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_23 = { class: "required" }
const _hoisted_24 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_25 = { class: "row mb-7" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_28 = { class: "required" }
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = { class: "col-12 col-lg-6" }
const _hoisted_31 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_32 = { class: "required" }
const _hoisted_33 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_34 = { class: "col-12 col-lg-6" }
const _hoisted_35 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = { class: "row mb-7" }
const _hoisted_42 = { class: "col-12 col-lg-9" }
const _hoisted_43 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_44 = { class: "" }
const _hoisted_45 = { class: "col-12 col-lg-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "UF")
], -1)
const _hoisted_47 = { class: "text-center pt-15" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-square-fill" }, null, -1)
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import {AxiosRequestConfig} from "axios";
import {Pix} from "@/store/modules/CheckoutModule";
import {useI18n} from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {type:String},
  emits: ['goBack', 'finish'],
  setup(__props, { emit }) {

const props = __props



const store = useStore();
const { t } = useI18n();
const saving = ref(false)
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const cpfOrCnpj = ref(true)

const data = ref({
  form:{
    name:'',
    document:'',
    phone: '',
    zip_code: '',
    street: '',
    number: '',
    district: '',
    city: '',
    state: '',
    complement:''
  }
})

data.value.form.name = store.getters.currentUser.name

Yup.addMethod(Yup.string, "validCPF", function(errorMessage){
  return this.test("validate-cpf", errorMessage, function(cpfString=''){
    let validated = false; // Start with false
    // Checking cpf lenght
    if (cpfString.length < 14) {
      return true;
    }

    if (cpfString.length === 14) {
      cpfString = cpfString.replace('.', '');
      cpfString = cpfString.replace('.', '');
      cpfString = cpfString.replace('-', '');
    }

    // Variables to check cpf valid (sum and rest)
    let sum = 0, rest = 0;

    // Checking for "null" CPF
    if (cpfString === '00000000000') {
      return validated;
    }

    // sum numbers
    for (let i = 1; i <= 9; ++i) {
      sum += (parseInt(cpfString.substring(i - 1, i)) * (11 - i));
    }

    // Getting rest
    rest = (sum * 10) % 11;

    if ((rest == 10) || (rest == 11)) {
      rest = 0;
    }

    if (rest != parseInt(cpfString.substring(9, 10))) {
      return validated;
    }

    validated = true;
    return validated;
  })
})
Yup.addMethod(Yup.string, "validCNPJ", function(errorMessage){
  return this.test("validate-cnpj", errorMessage, function(cnpjString=''){
    cnpjString = cnpjString.replace(/\D/g, '');
    let validated = false;
    if (cnpjString.length !== 14) {
      return false;
    }

    if (cnpjString.length === 14) {
      cnpjString = cnpjString.replace('.', '');
      cnpjString = cnpjString.replace('/', '');
      cnpjString = cnpjString.replace('.', '');
      cnpjString = cnpjString.replace('-', '');
    }

    let size = cnpjString.length - 2;
    let numbers = cnpjString.substring(0, size);
    let digits = cnpjString.substring(size);
    let sum = 0, pos = size - 7;

    if (cnpjString === '00000000000000') {
      return validated;
    }

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != digits.charAt(0)) {
      return validated;
    }

    size = size + 1;
    numbers = cnpjString.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != digits.charAt(1)) {
      return validated;
    }

    validated = true;
    return validated;
  })
})
const validationSchema = Yup.object().shape({
  name: Yup.string().required(t(`${currentLanguage.value}.profile.name_is_a_required_field`)),
  document: cpfOrCnpj.value ? Yup.string().required(t(`${currentLanguage.value}.messages.document_is_a_required_field`))
      .test('cpf-or-cnpj', t(`${currentLanguage.value}.messages.invalid_document_number`), function(value) {
        const { path, createError } = this;
        if (cpfOrCnpj.value) {
          return Yup.string().validCPF().isValidSync(value) || createError({ path, message: t(`${currentLanguage.value}.messages.invalid_document_number`) });
        } else {
          return Yup.string().validCNPJ().isValidSync(value) || createError({ path, message: t(`${currentLanguage.value}.messages.invalid_document_number`) });
        }
      }) : Yup.string().required(t(`${currentLanguage.value}.messages.document_is_a_required_field`)),
  zip_code: Yup.string().required(t(`${currentLanguage.value}.messages.zip_code_is_a_required_field`)),
  number: Yup.string().required(t(`${currentLanguage.value}.messages.number_is_a_required_field`)),
  street: Yup.string().required(t(`${currentLanguage.value}.messages.street_is_a_required_field`)),
  city: Yup.string().required(t(`${currentLanguage.value}.messages.city_is_a_required_field`)),
  state: Yup.string().required(t(`${currentLanguage.value}.messages.state_is_a_required_field`)),
});

const submitTest = async () => {
  
  // check validationSchema
  await validationSchema.validate(data.value.form).then(() => {
    
  }).catch((err) => {
    console.log("Error");
    console.log(err)
  })
}

const submit = async () => {

  
  const result_validation = await validationSchema.validate(data.value.form).then(() => {
    
    return true;
  }).catch((err) => {
    console.log("Error");
    console.log(err)
    // dispatch exception
    new Error(err);
    return false;
  });

  if(!result_validation){
    return;
  }

  saving.value = true
  const document = cpfOrCnpj.value ?
        data.value.form.document.replaceAll("-","").replaceAll(".", "") :
        data.value.form.document.replaceAll(".", "").replaceAll("/","").replaceAll("-","")

  data.value.form.document = document;

  try{
    await insertPayer()

    if(props.type == 'boleto'){
      const chargeData:any = await chargeBoleto()
      store.dispatch("updateBoletoUrl", chargeData.pdf)
    }else{
      const chargeData:any = await chargePix()
      store.dispatch("updatePix", chargeData as Pix)
    }

    emit('finish')
  }catch(e){
    Swal.fire({
          title: "Oops...",
          text: 'Tivemos um problema para gerar o '+props.type+', por favor entre em contato com o suporte através do WhatsApp abaixo!',
          icon: "error",
          confirmButtonText: "Ok",
        });
    console.error(e)
  }
  saving.value = false
}

const insertPayer = () =>{
  return new Promise(async (resolve, reject)=>{
    try{
      const phone = data.value.form.phone
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll(" ", "")
          .replaceAll("-", "")

      let json_data = {
        ... data.value.form,
        cpf_cnpj : data.value.form.document.replaceAll("-","").replaceAll(".", ""),
        phone_prefix: phone.substr(0, 2),
        phone: phone.substr(2,phone.length-2)
      }

      const payerResponse = await ApiService.post('payer/store', json_data as AxiosRequestConfig)

      resolve(payerResponse.data)
    }catch(e){
     // sweetAlertError(e)


      reject(e)
    }
  })
}

const chargeBoleto = ()=>{
  return new Promise(async(resolve, reject)=>{
    try{
      const request = {
        plan_id: store.getters.getPlan.id,
        method: "bank_slip",
        months: 1,
        cpf: data.value.form.document.replaceAll("-","").replaceAll(".", ""),
        card:{}
      }

      const chargeResponse = await ApiService.post('charge/store', request as AxiosRequestConfig)

      resolve(chargeResponse.data)
    }catch(e){
      reject(e)
    }
  })
}

const chargePix = ()=>{
  return new Promise(async(resolve, reject)=>{
    try{
      const request = {
        plan_id: store.getters.getPlan.id,
        cpf: data.value.form.document.replaceAll("-","").replaceAll(".", "")
      }

      const chargeResponse = await ApiService.post('invoice/iuguInvoiceStore', request as AxiosRequestConfig)

      resolve(chargeResponse.data)
    }catch(e){
      reject(e)
    }
  })
}


const getZipCodeInfo = async () => {
  const zipcode = data.value.form.zip_code.replaceAll('-', '')

  if(zipcode.length >= 8){
    try{
      const zipcode_response = await fetch(`https://viacep.com.br/ws/${zipcode}/json/`)
      const address_json = await zipcode_response.json()

      data.value.form.street = address_json.logradouro
      data.value.form.district = address_json.bairro
      data.value.form.city = address_json.localidade
      data.value.form.state = address_json.uf
    }catch(e){
      console.error(e)
    }
  }
}

const toggleCpfOrCnpj = ()=>{
  cpfOrCnpj.value = !cpfOrCnpj.value
  // if(data.value.form.document.length == 14){
  //   data.value.form.document = data.value.form.document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  // }else{
  //   data.value.form.document = data.value.form.document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  // }
}


return (_ctx: any,_cache: any) => {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "me-4",
          src: props.type == 'pix' ? '/media/payment-methods/pix.svg' : '/media/payment-methods/barcode.svg',
          style: {"width":"24px","filter":"invert(28%) sepia(67%) saturate(2000%) hue-rotate(242deg) brightness(79%) contrast(95%)"}
        }, null, 8, _hoisted_3),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(props.type=='pix'?'PIX':'Boleto') + " ", 1),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", {
        class: "cursor-pointer text-purple text-hover-secondary fs-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('goBack')))
      }, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(Form), {
        class: "form fv-plugins-bootstrap5 fv-plugins-framework",
        "validation-schema": _unref(validationSchema)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode(_toDisplayString(_unref(t)(`${_unref(currentLanguage)}.profile.billing.buy_with`)) + " ", 1),
                _createElementVNode("span", {
                  class: "ms-1 cursor-pointer text-success text-hover-success fs-6 bg-light rounded px-2 py-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleCpfOrCnpj()))
                }, _toDisplayString(cpfOrCnpj.value ? 'CNPJ' : 'CPF'), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.name`)), 1)
              ]),
              _createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                modelValue: data.value.form.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.form.name) = $event)),
                name: "name"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(ErrorMessage), { name: "name" })
              ])
            ])
          ]),
          (cpfOrCnpj.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "",
                  modelValue: data.value.form.document,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.form.document) = $event)),
                  name: "document"
                }, null, 8, ["modelValue"]), [
                  [_directive_maska, '###.###.###-##']
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(ErrorMessage), { name: "document" })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "",
                  modelValue: data.value.form.document,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.form.document) = $event)),
                  name: "document"
                }, null, 8, ["modelValue"]), [
                  [_directive_maska, '##.###.###/####-##']
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(ErrorMessage), { name: "document" })
                ])
              ])),
          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.address`)), 1),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.zip_code`)), 1)
              ]),
              _withDirectives(_createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                modelValue: data.value.form.zip_code,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.form.zip_code) = $event)),
                name: "zip_code",
                onInput: getZipCodeInfo
              }, null, 8, ["modelValue"]), [
                [_directive_maska, '#####-###']
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(ErrorMessage), { name: "zip_code" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.street`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Preenchiemento automático",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.form.street) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.street]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.number`)), 1)
              ]),
              _createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                modelValue: data.value.form.number,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.form.number) = $event)),
                name: "number"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_unref(ErrorMessage), { name: "number" })
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.complement`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.form.complement) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.complement]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.district`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Preenchiemento automático",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.value.form.district) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.district]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("label", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.city`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Preenchiemento automático",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((data.value.form.city) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Ex: SP",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((data.value.form.state) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.state]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              id: "kt_modal_new_card_submit",
              class: "btn btn-success",
              onClick: submit,
              type: "submit",
              disabled: saving.value
            }, [
              (!saving.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.button_member`)) + " ", 1),
                    _hoisted_50
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_51, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile.please_wait`)) + "... ", 1),
                    _hoisted_52
                  ]))
            ], 8, _hoisted_48)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ], 64))
}
}

})